<div
  class="comment-container"
  fxLayout="column"
  fxLayoutGap="44px"
  fxLayoutAlign="start center"
>
  <!-- shows comments from user is currentuser and with no replies-->
  <!-- <span class="comment-date">
    {{ msg?.dateCreated | date: "d, MMMM y | h:mm a" }}
  </span> -->
  <div
    class="current-user no-margin"
    *ngIf="user?.username == (msg?.createdBy | createdBy) && !isReply"
  >
    <div class="comment-header">
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="showReplyForm(msg)"
        >Reply</span
      >
      <div class="user-info">
        <span class="user-name"> {{ msg?.createdBy | createdBy }}</span>
        <img
          class="user-photo"
          *ngIf="user.image == 'assets/avatar/1.jpg' || !msg?.appUserImage"
          src="assets/avatar/1.jpg"
        />
        <img
          class="user-photo"
          *ngIf="user?.image != 'assets/avatar/1.jpg' || msg?.appUserImage"
          [src]="user?.image || msg?.appUserImage"
        />
      </div>
    </div>
  </div>

  <!-- shows comments from user not currentuser or view for creating a reply -->
  <div
    class="other-user no-margin"
    *ngIf="user.username !== (msg.createdBy | createdBy) || isReply"
  >
    <div class="comment-header">
      <div class="user-info">
        <span class="user-name">
          {{
            user.username !== (msg.createdBy | createdBy)
              ? "NCC Representative"
              : (msg.createdBy | createdBy)
          }}</span
        >
        <!-- <img
          class="user-photo"
          src="assets/images/ncc-logo.svg"
          *ngIf="user.username !== (msg.createdBy | createdBy)"
        /> -->
        <img
          *ngIf="user.username !== (msg.createdBy | createdBy)"
          class="user-photo"
          [src]="loadOrganizationImage(msg?.createdBy)"
        />
        <img
          *ngIf="user.username === (msg.createdBy | createdBy)"
          class="user-photo"
          [src]="loadImage(msg?.createdBy)"
        />
      </div>
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="showReplyForm(msg)"
        >Reply</span
      >
    </div>
  </div>
  <!-- show comment block in parent comment and comment view, that is with or without reply if user is current user -->
  <div
    class="current-user"
    *ngIf="user.username == (msg.createdBy | createdBy)"
  >
    <div class="content-area">
      <div *ngIf="msg.parentCommentId" class="reply-block">
        <span class="parent-data">
          {{
            (getCreatedBy(msg) | createdBy) === user.username
              ? (getCreatedBy(msg) | createdBy)
              : "NCC Representative"
          }}</span
        >
        <quill-view-html
          [content]="msg.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
      </div>

      <quill-view-html [content]="msg.comment" theme="snow"></quill-view-html>
      <span class="comment-time">
        {{ msg?.dateCreated | date: "h:mm a" }}
      </span>
    </div>

    <div class="attachment-field clickable" *ngIf="msg.documentMetadata">
      <span
        class="text"
        (click)="viewDocument(dataToJSON(msg?.documentMetadata))"
        >{{ dataToJSON(msg?.documentMetadata)?.documentName }}</span
      >
      <img
        class="icon"
        src="../../../../../../assets/icons/basil_document-outline.svg"
        alt="document icon"
      />
    </div>
  </div>
  <!-- show comment-reply block if not current user -->
  <div class="other-user" *ngIf="user.username !== (msg.createdBy | createdBy)">
    <div class="content-area">
      <div class="reply-block" *ngIf="msg.parentCommentId">
        <!-- <span class="parent-data">
          {{ dataToJSON(msg.parentCommentMetadata)?.createdBy | createdBy }}
        </span> -->
        <span class="parent-data">
          {{
            (getCreatedBy(msg) | createdBy) === user.username
              ? (getCreatedBy(msg) | createdBy)
              : "NCC Representative"
          }}</span
        >

        <quill-view-html
          [content]="msg.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
      </div>

      <quill-view-html [content]="msg.comment" theme="snow"></quill-view-html>
      <span class="comment-time">
        {{ msg.dateCreated | date: "h:mm a" }}
      </span>
    </div>
    <div class="attachment-field clickable" *ngIf="msg.documentMetadata">
      <span
        class="text"
        (click)="viewDocument(dataToJSON(msg?.documentMetadata))"
        >{{ dataToJSON(msg?.documentMetadata)?.documentName }}</span
      >
      <img
        class="icon"
        src="../../../../../../assets/icons/basil_document-outline.svg"
        alt="document icon"
      />
    </div>
  </div>
</div>
